module.exports = __webpack_public_path__ + "media/images/client-7-c7f033b713ff0e380caf373edad9a8ba.png";